module.exports = __webpack_public_path__ + "si.4279aabf.svg";